export default __webpack_public_path__ + "static/media/country.503e7166.svg";